import {
  TEMPLATE_PARAM,
  USE_CASE_PARAM,
  SUB_USE_CASE_PARAM,
  TEMPLATE_SEARCH_QUERY,
  OPEN_TEMPLATE_SEARCH_PANEL,
  TEMPLATE_CATEGORY_PARAM,
  FEATURE_ORIGIN_PARAM,
  FEED_INDEX_PARAM,
  NEW_DESIGN_PARAM,
  WORKSPACE_PARAM,
} from '@repo/editor/src/utils/window';

import { TemplateURLParams } from '..';

const buildTemplateUrlSearchParams = (
  urlParams?: TemplateURLParams
): URLSearchParams | null => {
  const {
    id,
    useCase,
    subUseCase,
    query,
    openTemplateSearchPanel,
    category,
    feedIndex,
    featureOrigin,
    isNewProject,
    workspaceId,
  } = urlParams ?? {};
  const transformedParams = {
    ...(id && { [TEMPLATE_PARAM]: id }),
    ...(useCase && { [USE_CASE_PARAM]: useCase }),
    ...(subUseCase && { [SUB_USE_CASE_PARAM]: subUseCase }),
    ...(query && { [TEMPLATE_SEARCH_QUERY]: query }),
    ...(openTemplateSearchPanel && { [OPEN_TEMPLATE_SEARCH_PANEL]: 'true' }),
    ...(category && { [TEMPLATE_CATEGORY_PARAM]: category }),
    ...(feedIndex && { [FEED_INDEX_PARAM]: feedIndex }),
    ...(featureOrigin && { [FEATURE_ORIGIN_PARAM]: featureOrigin }),
    ...(isNewProject && { [NEW_DESIGN_PARAM]: 't' }),
    ...(workspaceId && { [WORKSPACE_PARAM]: workspaceId }),
  };

  if (Object.keys(transformedParams).length === 0) {
    return null;
  }

  return new URLSearchParams(transformedParams);
};

export default buildTemplateUrlSearchParams;
